// Layout.tsx
import React, { useState } from 'react';
import { Link } from 'react-router';

interface Props {
  children: React.ReactNode;
}

export const AuthenticatedLayout: React.FC<Props> = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="bg-gray-100 h-screen flex flex-col md:flex-row font-sans"> {/* Added font-sans for professional look */}
      {/* Sidebar (Desktop) / Mobile Menu */}
      <aside className={`md:w-64 bg-white p-6 shadow-md transition-transform duration-300 ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 fixed top-0 left-0 h-full w-full md:w-64 z-10 bg-white`}>
        {/* Mobile Menu Button */}
        <button onClick={toggleMobileMenu} className="md:hidden text-2xl mb-6 text-gray-700 focus:outline-none">
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>

        {/* Sidebar Content */}
        <div className="flex flex-col h-full"> {/* Flex column to push content to top/bottom */}
          <div> {/* Top Section (Logo, etc.) */}
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Chatbot Options</h2>
            {/* Add your sidebar content here */}
            <ul className="text-gray-700">
              <li className="mb-2 hover:text-blue-500 cursor-pointer">Option 1</li>
              <li className="mb-2 hover:text-blue-500 cursor-pointer">Option 2</li>
              <li className="mb-2 hover:text-blue-500 cursor-pointer">Option 3</li>
            </ul>
          </div>

          <div className="mt-auto"> {/* Bottom Section (Logout, Settings, etc.) */}
            <div className="border-t border-gray-200 pt-6"> {/* Separator line */}
              <button className="text-gray-700 hover:text-blue-500 focus:outline-none">Logout</button>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 md:ml-64 p-6 overflow-y-auto bg-gray-50"> {/* Added background and padding */}
        <div className="bg-white rounded-lg shadow-md p-6 max-w-4xl mx-auto"> {/* Centered and constrained width */}
          {children} {/* This is where the Chatbot component will be rendered */}
        </div>
      </main>
    </div>
  );
};


export const AdminLayout: React.FC<Props> = ({ children }) => {
  return (
<div className="flex min-h-[100vh]">
    <div className="bg-white w-64 shadow-md">
    <div className="p-6">
      <h2 className="text-2xl font-bold text-blue-500">ChatBot Admin</h2>
    </div>
    <ul className="py-4">

    <Link to="/admin">
      <li className="px-6 py-3 hover:bg-gray-200 cursor-pointer">
        <span className="text-blue-500 mr-2">&#8618;</span> {/* Replace with your icon */}
        Dashboard
      </li>
      </Link>
      <Link to="/admin/documents">
      <li className="px-6 py-3 hover:bg-gray-200 cursor-pointer">
        Documents
      </li>
      </Link>
      <Link to="/admin/qa-management">
      <li className="px-6 py-3 hover:bg-gray-200 cursor-pointer">
        Q&A Management
      </li>
      </Link>
      <Link to="/admin/email-management">


      <li className="px-6 py-3 hover:bg-gray-200 cursor-pointer">
        Email Management
      </li>
    </Link>
    </ul>
  </div>
  {/* children */}
  <div className="flex-1">

    {children}
  </div>
  </div>
  )
}
